import { render, staticRenderFns } from "./DynamicTables.vue?vue&type=template&id=6fe27285&scoped=true"
import script from "./DynamicTables.vue?vue&type=script&lang=js"
export * from "./DynamicTables.vue?vue&type=script&lang=js"
import style0 from "./DynamicTables.vue?vue&type=style&index=0&id=6fe27285&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe27285",
  null
  
)

export default component.exports